<template>
  <b-container class="p-3" fluid>
    <portal v-if="$auth.check('coordinator')" to="project-action-bar">
      <template v-if="!editMode">
        <b-button v-if="!isEditModeDisabled" variant="info" @click="toggleEditMode"><font-awesome-icon icon="pencil-alt" />แก้ไขข้อมูล</b-button>
      </template>
      <template v-else>
        <b-button variant="success" class="mr-2" @click="save"><font-awesome-icon icon="save" />บันทึก</b-button>
        <b-button variant="outline-secondary" @click="toggleEditMode"><font-awesome-icon icon="times-circle" />ยกเลิก</b-button>
      </template>
    </portal>

    <b-row>
      <b-col>
        <div v-if="!$apollo.loading">
          <summary-information
            v-model="project.evaluation"
            :toggle-edit="editMode"
          />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import gql from 'graphql-tag'
import omitDeep from 'omit-deep-lodash'

import SummaryInformation from '@/components/project/evaluation/SummaryInformation'

export default {
  apollo: {
    project: {
      query: gql`query GetProject($id: ID!) { project(id: $id) { status, closureRejectReason, evaluation { conclusion, cooperation, obstacle, obstacleWorking, previousObstacle, comment } } }`,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  components: {
    SummaryInformation
  },
  data () {
    return {
      editMode: false,
      project: {
        evaluation: {
          comment: '',
          conclusion: '',
          cooperation: '',
          obstacle: '',
          obstacleWorking: '',
          previousObstacle: null
        }
      }
    }
  },
  computed: {
    isEditModeDisabled () {
      return this.project.status !== 'DraftForCloseProjectApproval'
    }
  },
  methods: {
    toggleEditMode () {
      this.editMode = !this.editMode
    },
    async save () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $input: ProjectEvaluationInput) { projectEvaluationEdit(id: $id, input: $input) { id } }`,
        variables: {
          id: this.$route.params.id,
          input: omitDeep(this.project.evaluation, '__typename')
        }
      }).then(() => {
        this.$bvToast.toast('แก้ไขข้อมูลสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })
      }).catch(() => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
        this.editMode = false
      })
      this.editMode = false
    },
    async submitForClosure () {
      if (confirm('เมื่อส่งแบบประเมินแล้ว จะไม่สามารถแก้ไขข้อมูลในส่วนการประเมินผลโครงการได้ ยืนยันการส่งหรือไม่?')) {
        await this.$apollo.mutate({
          mutation: gql`mutation ($id: ID!) { projectSubmitForClosure(id: $id) { id } }`,
          variables: { id: this.$route.params.id }
        }).then(() => {
          this.$bvToast.toast('ส่งแบบประเมินสำเร็จ', {
            title: 'สำเร็จ',
            variant: 'success',
            solid: true,
            noCloseButton: true
          })

          this.$apollo.queries.project.refetch()
        }).catch(() => {
          this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
            title: 'แจ้งเตือน',
            variant: 'danger',
            solid: true,
            noCloseButton: true
          })
        })
      }
    },
    async approveClosureRequest () {
      if (confirm('ยืนยันการอนุมัติปิดโครงการนี้หรือไม่?')) {
        await this.$apollo.mutate({
          mutation: gql`mutation ($id: ID!) { projectApproveClosureRequest(id: $id) { id } }`,
          variables: { id: this.$route.params.id }
        }).then(() => {
          this.$bvToast.toast('อนุมัติการปิดโครงการสำเร็จ', {
            title: 'สำเร็จ',
            variant: 'success',
            solid: true,
            noCloseButton: true
          })

          this.$apollo.queries.project.refetch()
        }).catch(() => {
          this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
            title: 'แจ้งเตือน',
            variant: 'danger',
            solid: true,
            noCloseButton: true
          })
        })
      }
    },
    async rejectClosureRequest () {
      let reason = prompt('โปรดระบุเหตุผลในการไม่อนุมัติปิดโครงการ')

      if (reason !== null) {
        await this.$apollo.mutate({
          mutation: gql`mutation ($id: ID!, $reason: String) { projectRejectClosureRequest(id: $id, reason: $reason) { id } }`,
          variables: { id: this.$route.params.id, reason }
        }).then(() => {
          this.$bvToast.toast('ปฏิเสธการปิดโครงการสำเร็จ', {
            title: 'สำเร็จ',
            variant: 'success',
            solid: true,
            noCloseButton: true
          })

          this.$apollo.queries.project.refetch()
        }).catch((error) => {
          let { graphQLErrors } = error
          this.errorMessage = 'เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง'
          if (graphQLErrors[0].extensions.category === 'custom') {
            this.errorMessage = graphQLErrors[0].message
          }
          this.$bvToast.toast(this.errorMessage, {
            title: 'แจ้งเตือน',
            variant: 'danger',
            solid: true,
            noCloseButton: true
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 250px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
